var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "17.804pt",
    height: "17.804pt",
    viewBox: "903.628 -797.597 17.804 17.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Imported Layer 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "scale(1 -1)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 912.531,793.043 L 912.531,786.583",
    fill: "none",
    stroke: "#323232",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 913.276,785.091 C 913.276,784.68 912.941,784.347 912.531,784.347 C 912.119,784.347 911.784,784.68 911.784,785.091 C 911.784,785.503 912.119,785.837 912.531,785.837 C 912.941,785.837 913.276,785.503 913.276,785.091 Z",
    stroke: "none",
    fill: "#323232",
    strokeLinejoin: "miter",
    markerStart: "none",
    markerEnd: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    strokeLinejoin: "miter",
    stroke: "#323232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 920.98,788.696 C 920.98,784.029 917.197,780.245 912.531,780.245 C 907.864,780.245 904.08,784.029 904.08,788.696 C 904.08,793.362 907.864,797.145 912.531,797.145 C 917.197,797.145 920.98,793.362 920.98,788.696 Z",
    markerStart: "none",
    markerEnd: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmallIcon);
export default __webpack_public_path__ + "static/media/info-small-icon.2e4dd996e7f842812e600a946885307a.svg";
export { ForwardRef as ReactComponent };